document.body.addEventListener('click', async event => {
	/*
		Triggered on .cl-po--swatch-button element clicks:
		- Populates personalisation modal with copy set within .js-personalisation-copy el
		- by moving element into modal window, triggered when personalisation button is clicked
	*/
	if (event.target.classList.contains('cl-po--swatch-button')) {
		// Get the modal, options group & personalisation copy elements
		const modalOptionsEl = await waitForElement('.cl-po--popup-options')
		const modalOptionsAddToCartEl = await modalOptionsEl.querySelector('.cl-po--popup .options-atc')
		const personalisationCopyEl = document.querySelector('.js-personalisation-copy')

		// Return here if either modal & personalisation elements do not exist
		if (!personalisationCopyEl || !modalOptionsEl) return

		// Get the hat box option element
		const hatBoxOptionEl = document.querySelector('.product-form .cl-po--option[data-option="Hat Box"]')

		// Move the personalisation copy element into the modal
		await modalOptionsEl.prepend(personalisationCopyEl)

		// If there's a hat box option element, move it to the modal options group el
		hatBoxOptionEl && await modalOptionsAddToCartEl.prepend(hatBoxOptionEl)
	}

	/*
		Triggered on .cl-po--popup-close element clicks:
		- Moves the hat box personalisation checkbox option to the product form
		- when personalisation modal close button is clicked
	*/
	if (event.target.classList.contains('cl-po--popup-close')) {
		const modalEl = event.target.parentElement
		// Get the personalisation options & hat box option elements
		const personalisationOptionsEl = document.querySelector('.product-form .cl-po--options')
		const hatBoxOptionEl = modalEl.querySelector('.cl-po--option[data-option="Hat Box"]')

		console.log(hatBoxOptionEl)

		// Return here if either personalisation options & hat box elements do not exist
		if (!personalisationOptionsEl || !hatBoxOptionEl) return

		// Move the hat box option element to the product form
		personalisationOptionsEl.append(hatBoxOptionEl)
	}
})

// Function to keep checking for an element until it exists
function waitForElement(selector) {
	return new Promise(resolve => {
		if (document.querySelector(selector)) {
			return resolve(document.querySelector(selector))
		}

		const observer = new MutationObserver(mutations => {
			if (document.querySelector(selector)) {
				observer.disconnect()
				resolve(document.querySelector(selector))
			}
		})

		// If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
		observer.observe(document.body, {
			childList: true,
			subtree: true
		})
	})
}
